import { render } from "./research-reports.vue?vue&type=template&id=1643c4cc&scoped=true"
import script from "./research-reports.vue?vue&type=script&lang=js"
export * from "./research-reports.vue?vue&type=script&lang=js"

import "./research-reports.vue?vue&type=style&index=0&id=1643c4cc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1643c4cc"]])

export default __exports__